import { render, staticRenderFns } from "./ManufacturingOverview.vue?vue&type=template&id=5672327a"
import script from "./ManufacturingOverview.vue?vue&type=script&lang=js"
export * from "./ManufacturingOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports